// extracted by mini-css-extract-plugin
export default {"page":"H3vPF36Um8pF6V0lxQP8","wrapper":"Yvlh8HXdaGuIBQwAbq2k","legal":"BR98GZUIvN6ypO0fQRqW"};